import { render } from "./chatlist.vue?vue&type=template&id=cd844518&scoped=true"
import script from "./chatlist.vue?vue&type=script&lang=ts"
export * from "./chatlist.vue?vue&type=script&lang=ts"

import "./chatlist.vue?vue&type=style&index=0&id=cd844518&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd844518"

export default script